import _ from 'lodash';

"use strict";
import { shouldApplyHallDefaultRadiologist } from '@/RazorTS/Orders/RadiologistDefaults';

window.refreshAdd = function() {
    function overwriteCustomFunctionsShared() {
        function SortPhysExportFormats(app) {
            var formats = $('#tblPhysExportFormats' + app).find('tr.efRecord');
            $.each(formats, function (index, obj) {
                $(formats[index]).find('input.physEFID').attr('name', app + 'ListPhysExportFormat[' + index + '].ID');
                $(formats[index]).find('input.physEFName').attr('name', app + 'ListPhysExportFormat[' + index + '].ExportFormat_Name');
                $(formats[index]).find('input.physEFEFID').attr('name', app + 'ListPhysExportFormat[' + index + '].ExportFormat_UID');
                $(formats[index]).find('input.physEFParameters').attr('name', app + 'ListPhysExportFormat[' + index + '].Parameters');
                $(formats[index]).find('input.physEFPartial').attr('name', app + 'ListPhysExportFormat[' + index + '].UseInPartial');
                $(formats[index]).find('input.physEFDefault').attr('name', app + 'ListPhysExportFormat[' + index + '].DefaultWhenNoPEF');
                $(formats[index]).find('input.physUID').attr('name', app + 'ListPhysExportFormat[' + index + '].Physician_UID');
                $(formats[index]).find('input.triggerStatus').attr('name', app + 'ListPhysExportFormat[' + index + '].TriggerStatus');
                $(formats[index]).find('input.physEFOrderTriggerStatus').attr('name', app + 'ListPhysExportFormat[' + index + '].OrderTriggerStatus_UID');
                $(formats[index]).find('input.physEFReportTriggerStatus').attr('name', app + 'ListPhysExportFormat[' + index + '].ReportTriggerStatus_UID');
            });
        }
        function checkOnDuty(e) {
            //Only check if the the day of implementation is actually a day that has onduty
            if ($.trim($('span#OnDutyLevelValueSpan').text()) != "") {
                var amount = $('table#selectedProcedures tr.selectedProcedureItem').length;
                if (amount == 0) {
                    $('input#OnDuty').prop('checked', true);
                    $('input#OnDuty').attr('checked', 'checked');
                } else {
                    if (amount == 1) {
                        var useOnDuty = $('table#selectedProcedures tr.selectedProcedureItem:first').find('td.procedure').find('input.useOnDuty').attr('value');
                        if (useOnDuty == "False" || useOnDuty == "false") {
                            $('input#OnDuty').prop('checked', false);
                            $('input#OnDuty').removeAttr('checked');
                        } else {
                            $('input#OnDuty').prop('checked', true);
                            $('input#OnDuty').attr('checked', 'checked');
                        }
                    } else {
                        if (amount > 1) {
                            var containsDontuseOnDuty = false;
                            $('table#selectedProcedures tr.selectedProcedureItem').each(function () {
                                var useOnDuty = $(this).find('td.procedure').find('input.useOnDuty').attr('value');
                                if (useOnDuty == "False" || useOnDuty == "false") {
                                    containsDontuseOnDuty = true;
                                }
                            });

                            $('input#OnDuty').prop('checked', !containsDontuseOnDuty);
                            if (containsDontuseOnDuty) {
                                $('input#OnDuty').prop('checked', false);
                                $('input#OnDuty').removeAttr('checked');
                            } else {
                                $('input#OnDuty').prop('checked', true);
                                $('input#OnDuty').attr('checked', 'checked');
                            }
                        }
                    }
                }
            }
        }
        function RefreshUrgencies() {
            const promise = fetch("/legacy/Orders/GetUrgencyIdForApplicantAndVisit?" +
                new URLSearchParams({
                    currentUrgencyId: modelUrgencyId,
                    ApplicantId: modelApplicantId,
                    VisitMovementId: modelVisitMovementId
                }),
                {
                    method: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }
            )
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                if (data != null && data.UrgencyId != null && data.UrgencyId != modelUrgencyId) {
                    var currentUrgency = $('#urgentList > li#' + modelUrgencyId);
                    var newUrgency = $('#urgentList > li#' + data.UrgencyId);
                    currentUrgency.removeClass('default');
                    newUrgency.addClass('default');
                    $('input#Urgent_UID').val(data.UrgencyId);
                    modelUrgencyId = data.UrgencyId;
                }
            })
            .catch(function () {
                console.log("Urgencies fail");
            });

            SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);
            return promise;
        }

        function GetInvoiceInformation(resetCustomTotals, radiologistChanged, amountPatientWasEdited, amountTotalWasEdited, manuallyAddedNomens) {
            resetCustomTotals = resetCustomTotals || false;
            amountPatientEdited = amountPatientWasEdited || amountPatientEdited;
            totalAmountEdited = amountTotalWasEdited || totalAmountEdited;

            const patientDOB = $('input[name="PatientModel.DateOfBirth"]').val() || viewbagPatientDOB;
            const patientGender = $('input[name="PatientModel.Gender"]').val() || viewbagPatientGender;
            const patientID = $('input[name="PatientModel.ID"]').val() || viewbagPatientID;

            SharedOrderFunctions.GetInvoiceInformationShared(
                resetCustomTotals,
                patientDOB,
                patientGender,
                patientID,
                null,
                amountPatientEdited,
                totalAmountEdited,
                invoiceMethod,
                companyFilled,
                radiologistChanged || false,
                manuallyAddedNomens
            );
        }

        function ConfirmInvoiceFunctionality(e) {
            SharedOrderFunctions.saveChecker.queueSave(() => checkIfOkToSave(true));
        }

        SharedOrderFunctions.saveButtons = $(`#btnAddOrder, #btnConfirmInvoice${viewbagUniquePrefix}, #btnConfirmPrepayment${viewbagUniquePrefix}`);
        SharedOrderFunctions.SortPhysExportFormats = SortPhysExportFormats;
        SharedOrderFunctions.checkOnDuty = checkOnDuty;
        SharedOrderFunctions.RefreshUrgencies = RefreshUrgencies;
        SharedOrderFunctions.GetInvoiceInformation = GetInvoiceInformation;
        SharedOrderFunctions.ConfirmInvoiceFunctionality = ConfirmInvoiceFunctionality;
    }

    overwriteCustomFunctionsShared();
    SharedOrderFunctions.reload_order_shared()

    window.GetInvoiceInformationFromVisit = function()
    {
        window.getInvoiceInformation();
    }

    window.getInvoiceInformation = function(resetCustomTotals){
        GetInvoiceInformation(resetCustomTotals);
    }

    const GetInvoiceInformation = function(resetCustomTotals, radiologistChanged) {
        SharedOrderFunctions.GetInvoiceInformation(resetCustomTotals, radiologistChanged || false);
    }

    window.setCG1CG2 = function(value) {
        SharedOrderFunctions.setCG1CG2(value);
    }

    var totalTabs = $(".ui-tabs-panel").size() - 1;

    var spinnerOptions = {
        step: 1,
        min: 1
    };

    var spinnerOptions2 = {
        numberFormat: "n",
        step: 0.1,
        min: 0,
        spin: function(e, ui) {
            var currentValue = parseFloat($(this).val());
            var nextValue;
            if (parseFloat(ui.value) > currentValue) {
                nextValue = currentValue + parseFloat("1.0");
            } else {
                nextValue = parseFloat(ui.value) >= 1 ? currentValue - parseFloat("1.0") : parseFloat("0");
            }
            $(this).val(nextValue % 1 === 0 ? nextValue.toFixed(0) : nextValue.toFixed(1));
            return false;
        }
    };

    var amountPatientEdited = false;
    var totalAmountEdited = false;
    var invoiceMethod = null;
    var companyFilled = false;

    if(viewbagDisableSupplements && viewbagDisableSupplements === 'True')
    {
        $('#AutoUpdateSupplement').prop('disabled', true);
        $('#InvoiceSupplement').prop('disabled', true);
    }


    if (viewbagSaveConfirmation && viewbagSaveConfirmation === 'True') {
        if (viewbagPrintFailed && viewbagPrintFailed === 'True') {
            $('#divPrintFailDialog p#printMessage').html(viewbagPrintFailMessage);
            $('#divPrintFailDialog').dialog('open');
        }
        $('#loading').show();
        $('#subPageContent').hide();
        closeActiveFile(true, true);
    } else {
        $('#loading').hide();

        $('button#btnLinkPrescription').removeAttr('disabled');
        $('button#btnOpenLinkDocumentDialog').removeAttr('disabled');

        $('#dialogMultiplePercentageOrCalculated').dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceAttention).text()
        });

        $('#btnCloseDialogMultiplePercentageOrCalculated').on('click', function (e) {
            $('#dialogMultiplePercentageOrCalculated').dialog('close');
        });

        $('#dialogAlreadyHadOrderToday' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceAttention).text()
        });

        $('#btnCloseDialogAlreadyHadOrderToday' + viewbagUniquePrefix).on('click', function (e) {
            $('#dialogAlreadyHadOrderToday' + viewbagUniquePrefix).dialog('close');
        });

        $('#dialogAlreadyHadProcedureRecently').dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceAttention).text()
        });

        $('button#btnCloseDialogAlreadyHadProcedureRecently').on('click', function (e) {
            $('#dialogAlreadyHadProcedureRecently').dialog("close");
        });

        var checkPatientProcedureHistory = function (procedure_ids) {

            //check if procedure was done in last 24 hours
            $.ajax({
                url: "/legacy/Orders/CheckPatientProcedureHistory",
                type: "GET",
                async: true,
                dataType: "json",
                data: {
                    Order_UID: modelID,
                    Procedure_UIDs: procedure_ids,
                    Patient_UID: modelPatientID,
                    Date: $('#DateOfImplementation').val()
                },
                success: function (data) {
                }
            });
        };

        var gConfirmInvoice;
        $('#dialogScanWarning' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceAttention).text()
        });

        $('#btnCancelScanWarning' + viewbagUniquePrefix).on('click', function (e) {
            $('#dialogScanWarning' + viewbagUniquePrefix).dialog('close');
        });
        $('#btnContinueScanWarning' + viewbagUniquePrefix).on('click', function (e) {
            $('#dialogScanWarning' + viewbagUniquePrefix).dialog('close');
            saveOrder(gConfirmInvoice);
        });


        var showRequestFormTab = function (e) {
            var ul = $tabs.find('ul#tabSource');
            if (ul.find('#openRequestFormTab').length == 0) {
                $('<li id="openRequestFormTab"><a href="#requestFormTabContent">' + resourceRequestForm + '</a></li>').appendTo(ul);
                ul.find('#openRequestFormTab').removeAttr('style');
                $('#tabs').find('#requestFormTabContent').removeAttr('style');
                $tabs.tabs("refresh");
            }

            setTimeout(function(){
                $('#request li.letter').removeClass('disabled');
                EditMode = true;
            }, 0);
        }

        var checkShowRequestFormTab = function (e) {
            var selected = $('table#selectedProcedures').find('tr.selectedProcedureItem');

            if (selected.length != 0) {
                var show = false;
                $.each(selected, function (index, obj) {
                    if ($(selected[index]).find('input.template').val() == 4) {
                        show = true;
                    }
                });
                if (show) {
                    showRequestFormTab();
                }
            }
        }

        checkShowRequestFormTab();


        $('#reloadPage').on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            $('#dialogReloadFile').find('input#rawURL').val("/Orders/Add/" + modelPatientID);
            $('#dialogReloadFile').dialog('open');
        });

        $('#printInvoice').on('click', function (e) {
            $.ajax({
                type: 'POST',
                url: '/legacy/Json/PrintInvoice',
                data: {
                    orderId: modelID
                },
                async: false
            });
        });


        $('input#loadPatient').on('click', function (e) {
            useFilingCabinet('/Patients/Detail/' + modelPatientID);
        });

        $('input#loadPatientHistory').on('click', function (e) {
            useFilingCabinet("/Patients/OrderHistory/" + modelPatientID);
        });

        var ResizeTopSubField = function (e) {
            var subField = $('form#addOrderForm').find('div.subField').first();
            var width = subField.width();
            var imageHolder = subField.find('div#imageHolder');
            var personalInfo = subField.find('div#personalInfo');
            personalInfo.width(width - imageHolder.width() - 20);
        }

        $(window).resize(function (e) {
            ResizeTopSubField();
        });

        ResizeTopSubField();

        $('#divEditHealthInsurance' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceEdit + " " + resourceHealthInsurance).text()
        });

        $('#divEditPatientMobile' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceEdit + " " + resourceMobileNumber).text()
        });

        $('#divEditHICG1CG2' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceEdit + " " + resourceCG1CG2Short).text()
        });

        $('#divEditHIINSZ' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceEdit + " " + resourceINSZ).text()
        });

        $('#divEditLength' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceEdit + " " + resourceLength).text()
        });

        $('#divEditWeight' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            title: $("<div/>").html(resourceEdit + " " + resourceWeight).text()
        });

        SharedOrderFunctions.registerPatientInfoDialogs(viewbagUniquePrefix);

        $('button#btnCloseEditHealthInsurance' + viewbagUniquePrefix).on('click', function (e) {
            $('#divEditHealthInsurance' + viewbagUniquePrefix).dialog("close");
        });

        $('button#btnCloseEditPatientMobile' + viewbagUniquePrefix).on('click', function (e) {
            $('#divEditPatientMobile' + viewbagUniquePrefix).dialog("close");
        });

        $('button#btnSaveAndCloseEditHealthInsurance' + viewbagUniquePrefix).on('click', function (e) {
            var divHolder = $('#divEditHealthInsurance' + viewbagUniquePrefix);
            var validation = divHolder.find('span.validation');
            var input = divHolder.find('dl dd input#PopupPatientHealthInsuranceText').val();

            if ($.trim(input) == "") {
                validation.show();
                validation.text(resourceErrorIsRequired);
                return false;
            }

            if (input.length > 100) {
                validation.show();
                validation.text(resourceErrorLength100);
                return false;
            }

            var inputID = divHolder.find('dl dd input#PopupPatientHealthInsuranceID').val();
            if (!$.isNumeric(inputID) || inputID == "0" || inputID == "") {
                validation.show();
                validation.text(resourceErrorValidHealthInsurance);
                return false;
            }

            $('#editHealthInsurance span.value').removeClass('none').removeClass('noneRequired');
            $('#editHealthInsurance span.value').text(input);
            $('#editHealthInsurance input#PatientHealthInsuranceText').val(input);
            $('#editHealthInsurance input#PatientHealthInsuranceID').val(inputID);
            $('#divEditHealthInsurance' + viewbagUniquePrefix).dialog("close");
        });

        var regexMobile = /^(?:\+\d{2}|00\d{2}|0)\d{9}$/;
        $('button#btnSaveAndCloseEditPatientMobile' + viewbagUniquePrefix).on('click', function (e) {
            var divHolder = $('#divEditPatientMobile' + viewbagUniquePrefix);
            var validation = divHolder.find('span.validation');
            var input = divHolder.find('dl dd input').val();

            input = input.replace('.', '').replace('/', '').replace('-', '').replace(' ', '')

            if (!regexMobile.test(input) && $.trim(input) != "") {
                validation.show();
                validation.text(resourceErrorValidMobile);
                return false;
            }

            if ($.trim(input) != "") {
                $('#editPatientMobile span.value').removeClass('none');
                $('#editPatientMobile').removeClass('noneMobile');
                $('#editPatientMobile span.value').text(input);
                $('#editPatientMobile input').val($.trim(input));
            } else {
                $('#editPatientMobile span.value').text(htmlDecode(resourceNone));
                $('#editPatientMobile span.value').addClass('none');
                $('#editPatientMobile').addClass('noneMobile');
                $('#editPatientMobile input').val('');
            }

            $('#divEditPatientMobile' + viewbagUniquePrefix).dialog("close");
        });

        $('#editHealthInsurance').on('click', function (e) {
            $('#divEditHealthInsurance' + viewbagUniquePrefix).dialog("open");
            $('#divEditHealthInsurance' + viewbagUniquePrefix).find('span.validation').hide();
            $('#divEditHealthInsurance' + viewbagUniquePrefix).find('dl dd input#PopupPatientHealthInsuranceText').val($(this).find('input#PatientHealthInsuranceText').val());
            $('#divEditHealthInsurance' + viewbagUniquePrefix).find('dl dd input#PopupPatientHealthInsuranceID').val($(this).find('input#PatientHealthInsuranceID').val());
        });

        $('#editPatientMobile').on('click', function (e) {
            $('#divEditPatientMobile' + viewbagUniquePrefix).dialog("open");
            $('#divEditPatientMobile' + viewbagUniquePrefix).find('span.validation').hide();
            $('#divEditPatientMobile' + viewbagUniquePrefix).find('dl dd input').val($(this).find('input').val());
        });

        $('ul#statusList li').on('click', function (e) {
            if (!$(this).hasClass('default') && $(this).hasClass('chooseable') && $('ul#statusList li.default').hasClass('changeable')) {
                $('ul#statusList li.default').removeClass('default');
                $(this).addClass('default');
                $('input#Status_UID').val($(this).attr('id'));
            }
        });

        $('ul#urgentList li').on('click', function (e) {
            if (!$(this).hasClass('default')) {
                $('ul#urgentList li.default').removeClass('default');
                $(this).addClass('default');
                $('input#Urgent_UID').val($(this).attr('id'));
                modelUrgencyId = $(this).attr('id');
            }
        });

        $('#publicRemarksShow').on('click', function (e) {
            e.stopImmediatePropagation();
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).text(resourceClickToOpen + '...');
                $('#dialogPublicRemarks' + viewbagUniquePrefix).dialog("close");
            } else {
                $(this).addClass('open');
                $(this).text(resourceClickToClose + '...');
                $('#dialogPublicRemarks' + viewbagUniquePrefix).dialog("open");
            }
        });

        $('#privateRemarksShow').on('click', function (e) {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).text(resourceClickToOpen + '...');
                $('#dialogPrivateRemarks' + viewbagUniquePrefix).dialog("close");
            } else {
                $(this).addClass('open');
                $(this).text(resourceClickToClose + '...');
                $('#dialogPrivateRemarks' + viewbagUniquePrefix).dialog("open");
            }
        });

        $('#publicRemarksShow').removeClass('open');
        $('#publicRemarksShow').text(resourceClickToOpen + '...');
        $('#privateRemarksShow').removeClass('open');
        $('#privateRemarksShow').text(resourceClickToOpen + '...');

        $('#dialogPublicRemarks' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: false,
            appendTo: "#contentView",
            dialogClass: "innerDialog",
            title: $("<div/>").html(resourcePublicRemarks).text(),
            close: function (e, ui) {
                $('#publicRemarksShow').removeClass('open');
                $('#publicRemarksShow').text(resourceClickToOpen + '...');
            }
        });

        $('#dialogPrivateRemarks' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: false,
            appendTo: "#contentView",
            dialogClass: "innerDialog",
            title: $("<div/>").html(resourcePrivateRemarks).text(),
            close: function (e, ui) {
                $('#privateRemarksShow').removeClass('open');
                $('#privateRemarksShow').text(resourceClickToOpen + '...');
            }
        });

        $(".actionMenu").menu({
            blur: function (e, ui) {
                return false;
            }
        });

        $('#divFindApplicant' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: "#contentView",
            title: $("<div/>").html(resourcedialogFindApplicant).text()
        });

        $('#divFindApplicantCC' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: "#contentView",
            title: $("<div/>").html(resourcedialogFindApplicantCC).text()
        });

        $('#divFindApplicantCC2' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: "#contentView",
            title: $("<div/>").html(resourcedialogFindApplicantCC2).text()
        });

        $('a#showAppDialog' + viewbagUniquePrefix).on('click', function (e) {
            $('#divFindApplicant' + viewbagUniquePrefix).dialog("open");
        });

        $('a#showAppCCDialog' + viewbagUniquePrefix).on('click', function (e) {
            $('#divFindApplicantCC' + viewbagUniquePrefix).dialog("open");
        });

        $('a#showAppCC2Dialog' + viewbagUniquePrefix).on('click', function (e) {
            $('#divFindApplicantCC2' + viewbagUniquePrefix).dialog("open");
        });

        $('button#btnCloseAppDialog' + viewbagUniquePrefix).on('click', function (e) {
            $('#divFindApplicant' + viewbagUniquePrefix).dialog("close");
        });

        $('button#btnCloseAppCCDialog' + viewbagUniquePrefix).on('click', function (e) {
            $('#divFindApplicantCC' + viewbagUniquePrefix).dialog("close");
        });

        $('button#btnCloseAppCC2Dialog' + viewbagUniquePrefix).on('click', function (e) {
            $('#divFindApplicantCC2' + viewbagUniquePrefix).dialog("close");
        });

        $('a#removeApp' + viewbagUniquePrefix).on('click', function (e) {
            if ($(this).hasClass('inActive')) {
                e.preventDefault();
            } else {
                modelApplicantId = null;
                SharedOrderFunctions.removeApplicant("App", viewbagUniquePrefix);
            }
        });

        $('a#removeAppCC' + viewbagUniquePrefix).on('click', function (e) {
            if ($(this).hasClass('inActive')) {
                e.preventDefault();
            } else {
                SharedOrderFunctions.removeApplicant("AppCC", viewbagUniquePrefix);
            }
        });

        $('a#removeAppCC2' + viewbagUniquePrefix).on('click', function (e) {
            if ($(this).hasClass('inActive')) {
                e.preventDefault();
            } else {
                SharedOrderFunctions.removeApplicant("AppCC2", viewbagUniquePrefix);
            }
        });

        $('#txtFindAppName' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicant();
                return false;
            }
        });
        $('#txtFindAppAddress' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicant();
                return false;
            }
        });
        $('#txtFindAppRIZIV' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicant();
                return false;
            }
        });
        $('#dropFindAppType').on('change', function (e) {
            findApplicant();
        });
        $('#dropFindAppDepartment').on('change', function (e) {
            findApplicant();
        });
        $('#txtFindAppCCName' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicantCC();
                return false;
            }
        });
        $('#txtFindAppCCAddress' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicantCC();
                return false;
            }
        });
        $('#txtFindAppCCRIZIV' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicantCC();
                return false;
            }
        });
        $('#dropFindAppCCType').on('change', function (e) {
            findApplicantCC();
        });
        $('#dropFindAppCCDepartment').on('change', function (e) {
            findApplicantCC();
        });
        $('#txtFindAppCC2Name' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicantCC2();
                return false;
            }
        });
        $('#txtFindAppCC2Address' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicantCC2();
                return false;
            }
        });
        $('#txtFindAppCC2RIZIV' + viewbagUniquePrefix).on('keydown', function (e) {
            if (e.keyCode == 13) {
                findApplicantCC2();
                return false;
            }
        });
        $('#dropFindAppCC2Type').on('change', function (e) {
            findApplicantCC2();
        });
        $('#dropFindAppCC2Department').on('change', function (e) {
            findApplicantCC2();
        });

        var findApplicant = function (e) {
            $.ajax({
                type: 'POST',
                url: '/legacy/Orders/FindPhysiciansForGrid',
                data: {
                    Name: $('#txtFindAppName' + viewbagUniquePrefix).val(),
                    Address: $('#txtFindAppAddress' + viewbagUniquePrefix).val(),
                    RIZIV: $('#txtFindAppRIZIV' + viewbagUniquePrefix).val(),
                    except: $('#Applicant_CC_UID').val() + "-" + $('#Applicant_CC_2_UID').val(),
                    Type: $('#dropFindAppType').val(),
                    Department: $('#dropFindAppDepartment').val()
                },
                dataType: 'json',
                success:
                    function (data) {
                        $('#gridFindApplicant' + viewbagUniquePrefix + ' tr:not(.tableHeader)').remove();
                        $("#btnLoadSelectedApp" + viewbagUniquePrefix).attr("disabled", true);
                        if (data.items.length > 0) {
                            $.each(data.items, function (e) {
                                $('#gridFindApplicant' + viewbagUniquePrefix).append('<tr class="record"><td class="rowId">' + this.ID + '</td><td class="rowName">' + this.FullName + '</td><td class="rowContactId">' + this.ContactInformationID + '</td><td class="rowContactInformation">' + this.ContactInformation + '</td><td>' + this.Type + '</td><td>' + this.Department + '</td><td>' + this.RIZIV + '</td></tr>');
                            });
                        } else {
                            $('#gridFindApplicant' + viewbagUniquePrefix).append('<tr class="noRecords"><td colspan="6">' + resourceNoPhysiciansFound + '</td></tr>');
                        }
                    }
            });
        }

        var findApplicantCC = function (e) {
            $.ajax({
                type: 'POST',
                url: '/legacy/Orders/FindPhysiciansForGrid',
                data: {
                    Name: $('#txtFindAppCCName' + viewbagUniquePrefix).val(),
                    Address: $('#txtFindAppCCAddress' + viewbagUniquePrefix).val(),
                    RIZIV: $('#txtFindAppCCRIZIV' + viewbagUniquePrefix).val(),
                    except: $('#Applicant_UID').val() + "-" + $('#Applicant_CC_2_UID').val(),
                    Type: $('#dropFindAppCCType').val(),
                    Department: $('#dropFindAppCCDepartment').val()
                },
                dataType: 'json',
                success:
                    function (data) {
                        $('#gridFindApplicantCC' + viewbagUniquePrefix + ' tr:not(.tableHeader)').remove();
                        $("#btnLoadSelectedAppCC" + viewbagUniquePrefix).attr("disabled", true);
                        if (data.items.length > 0) {
                            $.each(data.items, function (e) {
                                $('#gridFindApplicantCC' + viewbagUniquePrefix).append('<tr class="record"><td class="rowId">' + this.ID + '</td><td class="rowName">' + this.FullName + '</td><td class="rowContactId">' + this.ContactInformationID + '</td><td class="rowContactInformation">' + this.ContactInformation + '</td><td>' + this.Type + '</td><td>' + this.Department + '</td><td>' + this.RIZIV + '</td></tr>');
                            });
                        } else {
                            $('#gridFindApplicantCC' + viewbagUniquePrefix).append('<tr class="noRecords"><td colspan="6">' + resourceNoPhysiciansFound + '</td></tr>');
                        }
                    }
            });
        }

        var findApplicantCC2 = function (e) {
            $.ajax({
                type: 'POST',
                url: '/legacy/Orders/FindPhysiciansForGrid',
                data: {
                    Name: $('#txtFindAppCC2Name' + viewbagUniquePrefix).val(),
                    Address: $('#txtFindAppCC2Address' + viewbagUniquePrefix).val(),
                    RIZIV: $('#txtFindAppCC2RIZIV' + viewbagUniquePrefix).val(),
                    except: $('#Applicant_CC_UID').val() + "-" + $('#Applicant_UID').val(),
                    Type: $('#dropFindAppCC2Type').val(),
                    Department: $('#dropFindAppCC2Department').val()
                },
                dataType: 'json',
                success:
                    function (data) {
                        $('#gridFindApplicantCC2' + viewbagUniquePrefix + ' tr:not(.tableHeader)').remove();
                        $("#btnLoadSelectedAppCC2" + viewbagUniquePrefix).attr("disabled", true);
                        if (data.items.length > 0) {
                            $.each(data.items, function (e) {
                                $('#gridFindApplicantCC2' + viewbagUniquePrefix).append('<tr class="record"><td class="rowId">' + this.ID + '</td><td class="rowName">' + this.FullName + '</td><td class="rowContactId">' + this.ContactInformationID + '</td><td class="rowContactInformation">' + this.ContactInformation + '</td><td>' + this.Type + '</td><td>' + this.Department + '</td><td>' + this.RIZIV + '</td></tr>');
                            });
                        } else {
                            $('#gridFindApplicantCC2' + viewbagUniquePrefix).append('<tr class="noRecords"><td colspan="6">' + resourceNoPhysiciansFound + '</td></tr>');
                        }
                    }
            });
        }

        $('#gridFindApplicant' + viewbagUniquePrefix).on('click', 'tr.record', function (e) {
            $(this).parent().find('tr.focus').removeClass('focus');
            $(this).addClass('focus');
            $("#btnLoadSelectedApp" + viewbagUniquePrefix).removeAttr("disabled");
        });

        $('#gridFindApplicantCC' + viewbagUniquePrefix).on('click', 'tr.record', function (e) {
            $(this).parent().find('tr.focus').removeClass('focus');
            $(this).addClass('focus');
            $("#btnLoadSelectedAppCC" + viewbagUniquePrefix).removeAttr("disabled");
        });

        $('#gridFindApplicantCC2' + viewbagUniquePrefix).on('click', 'tr.record', function (e) {
            $(this).parent().find('tr.focus').removeClass('focus');
            $(this).addClass('focus');
            $("#btnLoadSelectedAppCC2" + viewbagUniquePrefix).removeAttr("disabled");
        });

        $('#gridFindApplicant' + viewbagUniquePrefix).on('dblclick', 'tr.record', function (e) {
            $(this).parent().find('tr.focus').removeClass('focus');
            $(this).addClass('focus');
            $("#btnLoadSelectedApp" + viewbagUniquePrefix).removeAttr("disabled");
            SharedOrderFunctions.LoadSelectedApplicant(viewbagUniquePrefix);
        });

        $('#gridFindApplicantCC' + viewbagUniquePrefix).on('dblclick', 'tr.record', function (e) {
            $(this).parent().find('tr.focus').removeClass('focus');
            $(this).addClass('focus');
            $("#btnLoadSelectedAppCC" + viewbagUniquePrefix).removeAttr("disabled");
            SharedOrderFunctions.LoadSelectedAppCC(viewbagUniquePrefix);
        });

        $('#gridFindApplicantCC2' + viewbagUniquePrefix).on('dblclick', 'tr.record', function (e) {
            $(this).parent().find('tr.focus').removeClass('focus');
            $(this).addClass('focus');
            $("#btnLoadSelectedAppCC2" + viewbagUniquePrefix).removeAttr("disabled");
            SharedOrderFunctions.LoadSelectedAppCC2(viewbagUniquePrefix);
        });

        $('#btnLoadSelectedApp' + viewbagUniquePrefix).on('click', function (e) {
            SharedOrderFunctions.LoadSelectedApplicant(viewbagUniquePrefix);
        });

        $('#btnLoadSelectedAppCC' + viewbagUniquePrefix).on('click', function (e) {
            SharedOrderFunctions.LoadSelectedAppCC(viewbagUniquePrefix);
        });

        $('#btnLoadSelectedAppCC2' + viewbagUniquePrefix).on('click', function (e) {
            SharedOrderFunctions.LoadSelectedAppCC2(viewbagUniquePrefix);
        });

        $('a#showAppDetail' + viewbagUniquePrefix).on('click', function (e) {
            if ($(this).hasClass('inActive')) {
                e.preventDefault();
            } else {
                var id = $('input#Applicant_UID').val();
                useFilingCabinet('/Physicians/Detail/' + id);
            }
        });

        $('a#showAppCCDetail' + viewbagUniquePrefix).on('click', function (e) {
            if ($(this).hasClass('inActive')) {
                e.preventDefault();
            } else {
                var id = $('input#Applicant_CC_UID').val();
                useFilingCabinet('/Physicians/Detail/' + id);
            }
        });

        $('a#showAppCC2Detail' + viewbagUniquePrefix).on('click', function (e) {
            if ($(this).hasClass('inActive')) {
                e.preventDefault();
            } else {
                var id = $('input#Applicant_CC_2_UID').val();
                useFilingCabinet('/Physicians/Detail/' + id);
            }
        });

        $('#Applicant_Text').autocomplete({
            autoFocus: true,
            source: function (request, response) {
                SharedOrderFunctions.resetAndSetLoadingApplicantForAutocomplete("App", viewbagUniquePrefix);

                const applicantValue = $('#Applicant_UID').val();
                const applicantID = applicantValue === '0' ? null : parseInt(applicantValue);
                const applicantCCValue = $('#Applicant_CC_UID').val();
                const applicantCCID = applicantCCValue === '0' ? null : parseInt(applicantCCValue);
                const applicantCC2Value = $('#Applicant_CC_2_UID').val();
                const applicantCC2ID = applicantCC2Value === '0' ? null : parseInt(applicantCC2Value);

                const exclusionIDs = [applicantCCID, applicantCC2ID].filter(id => id !== null);

                const params = new URLSearchParams( { term: request.term } );
                exclusionIDs.forEach(exclusionID => {
                    params.append("except", exclusionID);
                });

                fetch('/core/physician/autocomplete?' +
                    params, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        "X-Requested-With": "XMLHttpRequest"
                    }})
                .then(res => res.json())
                .then(data => {
                    SharedOrderFunctions.setAutocompleteApplicantLoading(false, "App", data, response);
                });
            },
            minLength: 2,
            delay: 500,
            select: function (event, ui) {
                event.preventDefault();

                const appId = ui.item.id;
                SharedOrderFunctions.LoadApplicantWithID(appId, "App", viewbagUniquePrefix);
            }
        });

        $('#Applicant_ContactID').on('change' , function () {
            SharedOrderFunctions.LoadPhyscianExportFormatsForApplicantType('App');
        });

        $('#Applicant_CC_Text').autocomplete({
            autoFocus: true,
            source: function (request, response) {
                SharedOrderFunctions.resetAndSetLoadingApplicantForAutocomplete("AppCC", viewbagUniquePrefix);

                const applicantValue = $('#Applicant_UID').val();
                const applicantID = applicantValue === '0' ? null : parseInt(applicantValue);
                const applicantCCValue = $('#Applicant_CC_UID').val();
                const applicantCCID = applicantCCValue === '0' ? null : parseInt(applicantCCValue);
                const applicantCC2Value = $('#Applicant_CC_2_UID').val();
                const applicantCC2ID = applicantCC2Value === '0' ? null : parseInt(applicantCC2Value);

                const exclusionIDs = [applicantID, applicantCC2ID].filter(id => id !== null);

                const params = new URLSearchParams( { term: request.term } );
                exclusionIDs.forEach(exclusionID => {
                    params.append("except", exclusionID);
                });

                fetch('/core/physician/autocomplete?' +
                    params, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        "X-Requested-With": "XMLHttpRequest"
                    }})
                .then(res => res.json())
                .then(data => {
                    SharedOrderFunctions.setAutocompleteApplicantLoading(false, "AppCC", data, response);
                });
            },
            minLength: 2,
            delay: 500,
            select: function (event, ui) {
                event.preventDefault();

                var appCCId = ui.item.id;
                SharedOrderFunctions.LoadApplicantWithID(appCCId, "AppCC", viewbagUniquePrefix);
            }
        });


        $('#Applicant_CC_ContactID').on('change' , function () {
            SharedOrderFunctions.LoadPhyscianExportFormatsForApplicantType('AppCC');
        });

        $('#Applicant_CC_2_Text').autocomplete({
            autoFocus: true,
            source: function (request, response) {
                SharedOrderFunctions.resetAndSetLoadingApplicantForAutocomplete("AppCC2", viewbagUniquePrefix);

                const applicantValue = $('#Applicant_UID').val();
                const applicantID = applicantValue === '0' ? null : parseInt(applicantValue);
                const applicantCCValue = $('#Applicant_CC_UID').val();
                const applicantCCID = applicantCCValue === '0' ? null : parseInt(applicantCCValue);
                const applicantCC2Value = $('#Applicant_CC_2_UID').val();
                const applicantCC2ID = applicantCC2Value === '0' ? null : parseInt(applicantCC2Value);

                const exclusionIDs = [applicantID, applicantCCID].filter(id => id !== null);

                const params = new URLSearchParams( { term: request.term } );
                exclusionIDs.forEach(exclusionID => {
                    params.append("except", exclusionID);
                });

                fetch('/core/physician/autocomplete?' +
                    params, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        "X-Requested-With": "XMLHttpRequest"
                    }})
                .then(res => res.json())
                .then(data => {
                    SharedOrderFunctions.setAutocompleteApplicantLoading(false, "AppCC2", data, response);
                });
            },
            minLength: 2,
            delay: 500,
            select: function (event, ui) {
                event.preventDefault();

                var appCC2Id = ui.item.id;
                SharedOrderFunctions.LoadApplicantWithID(appCC2Id, "AppCC2", viewbagUniquePrefix);
            }
        });

        $('#Applicant_CC_2_ContactID').on('change' , function () {
            SharedOrderFunctions.LoadPhyscianExportFormatsForApplicantType('AppCC2');
        });

        var m = moment($('#age').html(), "DD/MM/YYYY");
        if (m.isValid()) {
            $('#age').html('(' + moment().diff(m, 'years') + ')');
        }

        $('a[href="#"]').on('click', function (e) {
            e.preventDefault();
        });

        $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());

        $('select').each(function (e) {
            if ($(this).attr('value') != null) {
                $(this).val($(this).attr('value'));
            }
        });

        $('textarea').each(function (e) {
            if ($(this).attr('value') != null) {
                $(this).val($(this).attr('value'));
            }
        });

        $("body").keydown(function (e) {
            if (!$(e.target).is('input')) {
                if (e.keyCode == 37) { // left
                    ScrollLeft();
                    return false;
                } else if (e.keyCode == 39) { // right
                    ScrollRight();
                    return false;
                }
            }
        });

        $('#searchProcedure')
            .change(function () {
                if ($(this).val() !== '') {
                    return;
                }
                $('#emptyProcedures').text(viewbagAvailableProceduresCount + $('<div/>').html(' ' + resourceProceduresFound).text());
            })
            .keyup(function () {
                $(this).change();
            });

        var onAutoCompleteEnter = false;
        $('input#searchProcedure').on('keypress', function (e) {
            e.stopImmediatePropagation();
            
            if (e.keyCode === 13 && $(this).val() !== "") {
                if (!onAutoCompleteEnter) {
                    e.preventDefault();

                    const filter = $(this).val().toLowerCase();
                    const matches = currentProceduresList.filter(function (obj) {
                        return obj.Code.toLowerCase().includes(filter) || obj.FullCode.toLowerCase().includes(filter) || obj.Description.toLowerCase().includes(filter)
                            || obj.Modality_Text.toLowerCase().includes(filter)
                    });

                    if (matches.length > 0) {
                        selectProcedure(matches[0].ID);

                        $('input#searchProcedure').val("");
                        $('input#searchProcedure').attr("value", "");
                        $('input#searchProcedure').autocomplete("close");
                        $('#emptyProcedures').text(viewbagAvailableProceduresCount + $('<div/>').html(' ' + resourceProceduresFound).text());
                        onAutoCompleteEnter = false;
                    }
                } else {
                    onAutoCompleteEnter = false;
                }
                return false;
            }
        });

        let currentProceduresList = [];
        $('input#searchProcedure').autocomplete({
            autoFocus: false,
            source: function (request, response) {
                setAutocompleteInputLoading(true, $('input#searchProcedure'));
                $.ajax({
                    url: "/legacy/Json/AutoCompleteProcedures",
                    type: "GET",
                    dataType: "json",
                    data: {
                        term: request.term,
                        date: $('#DateOfImplementation').val(),
                        patientID: modelPatientID,
                        includeGroups: true
                    },
                    success: function (data) {
                        currentProceduresList = data;
                        setAutocompleteInputLoading(false, $('input#searchProcedure'));
                        $('#emptyProcedures').text(data.length + $('<div/>').html(' ' + resourceProceduresFound).text());
                        
                        response($.map(data, function (item) {
                            return {
                                label: item.Modality_Text + ' ' + item.Code + " (" + item.Description + ")",
                                value: item.Code,
                                id: item.IDString
                            };
                        }))
                    }
                })
            },
            minLength: 1,
            select: function (event, ui) {
                event.stopPropagation();
                event.preventDefault();
                
                onAutoCompleteEnter = true;
                if (ui.item.id.indexOf('_') > 0) {
                    $.each(ui.item.id.split('_'), function (i, y) {
                        if (y != "") {
                            selectProcedure(y);
                        }
                    });
                } else {
                    selectProcedure(ui.item.id);
                }
                $('input#searchProcedure').val("");
                $('input#searchProcedure').attr("value", "");
                $('#emptyProcedures').text(viewbagAvailableProceduresCount + $('<div/>').html(' ' + resourceProceduresFound).text());
            },
            close: function (event, ui) {
                if (event.originalEvent !== undefined) {
                    if (event.originalEvent.type == "blur") {
                        onAutoCompleteEnter = false;
                    }
                }
            }
        });

        var selectProcedure = function (procedureID) {
            const procedure = _.find(currentProceduresList, function (obj) {
                return obj.ID === parseInt(procedureID)
            });
            const id = procedure.ID;
            const fullCode = procedure.Description;
            const code = procedure.Code;
            const color = procedure.Color;
            const modality = procedure.Modality_Text;
            const useOnDuty = procedure.UseOnDuty;
            const procedureTemplateUID = procedure.TemplateUID;
            const screeningsTemplateUID = procedure.ScreeningTemplateUID;
            const justificationType = procedure.JustificationType;
            const leftRight = procedure.LeftRight;
            
            let statusToUse = 1;
            const existingStatusArr = new Array();
            try {
                $('.statusDrop').each(function () {
                    existingStatusArr.push(parseInt($(this).val()));
                });
            } catch (e) {
            }

            const orderStatus = $('#statusList').find('li.default').attr('id');
            if (orderStatus != 1) {
                statusToUse = parseInt(viewbagDefaultProcedureStatus);
            }
            
            let toAppend = '<tr class="selectedProcedureItem tableRecord" id="' + id + '">';
            toAppend += '<td class="procedure" style="background-color:' + color + '" title="' + fullCode + '"><span class="insideProcedureItemContainer"><b>' + modality + '</b> ' + code + '</span>';
            toAppend += '<input type="hidden" class="modality" name="ListProcedureItems[' + index + '].Modality_Text" value="' + modality + '"/>';
            toAppend += '<input type="hidden" class="id" name="ListProcedureItems[' + index + '].ID" value="' + id + '"/>';
            toAppend += '<input type="hidden" class="color" name="ListProcedureItems[' + index + '].Color" value="' + color + '"/>';
            toAppend += '<input type="hidden" class="code" name="ListProcedureItems[' + index + '].Code" value="' + code + '"/>';
            toAppend += '<input type="hidden" class="fullCode" name="ListProcedureItems[' + index + '].FullCode" value="' + fullCode + '"/>';
            toAppend += '<input type="hidden" class="useOnDuty" name="ListProcedureItems[' + index + '].UseOnDuty" value="' + useOnDuty + '"/>';
            toAppend += '<input type="hidden" class="template" name="ListProcedureItems[' + index + '].TemplateUID" value="' + procedureTemplateUID + '"/>';
            toAppend += '<input type="hidden" class="screeningTemplate" name="ListProcedureItems[' + index + '].ScreeningTemplateUID" value="' + screeningsTemplateUID + '"/></td>';
            toAppend += '<input type="hidden" class="justificationType" name="ListProcedureItems[' + index + '].JustificationType" value="' + justificationType + '"/></td>';
            toAppend += '<input type="hidden" class="leftRight" name="ListProcedureItems[' + index + '].LeftRight" value="' + leftRight + '"/></td>';
            toAppend += '<td class="radiologist"><input type="text" class="radText" name="ListProcedureItems[' + index + '].Radiologist_Text" value="" /><input type="hidden" class="radUid" name="ListProcedureItems[' + index + '].Radiologist_UID" value="" /></td>';
            toAppend += '<td class="technician"><input type="text" class="tecText" name="ListProcedureItems[' + index + '].Technician_Text" value="" /><input type="hidden" class="tecUid" name="ListProcedureItems[' + index + '].Technician_UID" value="" /></td>';
            toAppend += '<td class="room"><input type="text" class="roomText" name="ListProcedureItems[' + index + '].Room_Text" value="" /><input type="hidden" class="roomUID" name="ListProcedureItems[' + index + '].Room_UID" value="" /></td>';
            toAppend += '<td class="status"><select name="ListProcedureItems[' + index + '].Status_UID" class="drop-down statusDrop">';
            for (let key = 0; key < viewbagAvailableProcedureStatus.length; key++) {
                let change = false;
                let choose = false;

                let statusClass = "";
                if (viewbagAvailableProcedureStatus[key].Choose) {
                    statusClass += " chooseable";
                    choose = true;
                } else {
                    statusClass += " notChooseable";
                }
                if (viewbagAvailableProcedureStatus[key].Change) {
                    statusClass += " changeable";
                    change = true;
                } else {
                    statusClass += " notChangeable";
                }

                if (viewbagAvailableProcedureStatus[key].ID == statusToUse) {
                    toAppend += '<option value="' + viewbagAvailableProcedureStatus[key].ID + '" class="@statusClass" selected="selected">' + viewbagAvailableProcedureStatus[key].Text + '</option>';
                } else {
                    toAppend += '<option value="' + viewbagAvailableProcedureStatus[key].ID + '" class="@statusClass" @(!choose ? "disabled=disabled" : "")>' + viewbagAvailableProcedureStatus[key].Text + '</option>';
                }
            }
            toAppend += '</select></td>';
            toAppend += '<td class="implementation"><input type="text" class="procImplementation" name="ListProcedureItems[' + index + '].Implementation" value="' + $('#DateOfImplementation').val() + '" /><input type="hidden" class="procPlanned" name="ListProcedureItems[' + index + '].DateTimePlanned" value="' + $('#DateOfImplementation').val() + '" /></td>';
            toAppend += '<td class="substitution"><input type="checkbox" class="substitution" id="ListProcedureItems_' + index + '__Substitution" name="ListProcedureItems[' + index + '].Substitution" value="true" data-val="true"><input type="hidden" value="false" name="ListProcedureItems[' + index + '].Substitution"></td>';
            toAppend += '<td class="delete">Delete</td></tr>';

            $('table#selectedProcedures').append($(toAppend));
            $('.radText').autocomplete(autocompleteRadiologists);
            $('.tecText').autocomplete(autocompleteTechnicians);
            $('.roomText').autocomplete(autocompleteRooms);

            const selectedRow = $('table#selectedProcedures').find('tr#' + id);
            SetDefaultRadiologist(selectedRow.find('td.radiologist'));
            const techPromise = SharedOrderFunctions.SetDefaultTechnician(selectedRow.find('td.technician'), viewbagDefaultTechnicianUID);
            const roomPromise = SharedOrderFunctions.SetDefaultRoomFromOrderContext(selectedRow, viewbagDefaultRoomUID, viewbagDefaultRoomText);

            $(this).css('opacity', '0.3');
            $('table#selectedProcedures tr#emptyTable').hide();

            Promise.all([ techPromise, roomPromise ])
                .then(() => {
                    SortSelectedProcedures();
                    SharedOrderFunctions.GetAndSetProcedureExportFormatsForProcedureWithID(id);

                    var ul = $tabs.find('ul#tabSource');

                    if (procedureTemplateUID == 4 && !ul.find('#openRequestFormTab').length) {
                        containsRequestForm = true;
                        showRequestFormTab();
                    }

                    if (viewbagUseMotivationLetters && viewbagUseMotivationLetters === 'True') {
                        SharedOrderFunctions.checkMotivationLetters();
                    }
                    checkPatientProcedureHistory(id);
                })
                .catch((error) => {
                    console.error('Error setting defaults for procedure:', error);
                });
        }

        var index = 0;

        var containsRequestForm = false;


        $('body').off('click', '#tblProcedureExportFormat td.delete');
        $('body').on('click', '#tblProcedureExportFormat td.delete', function (e) {
            e.stopImmediatePropagation();
            $(this).parent().remove();
            SharedOrderFunctions.SortProceduresExportFormats();
        });

        $('body').off('click', 'table#selectedProcedures td.delete');
        $('body').on('click', 'table#selectedProcedures td.delete', function (e) {
            //e.stopImmediatePropagation();
            var id = $(this).parent().attr('id');

            var procedureTemplateUID = $(this).parent().find('td.procedure').find('input.template').val();
            var procedurecount = 0;
            $.each($('table#selectedProcedures').find('tr.selectedProcedureItem').find('td.procedure'), function (index, obj) {
                if ($(this).find('input.template').val() == 4) {
                    procedurecount++;
                }
            })

            if (procedureTemplateUID == 4 && procedurecount == 1) {
                $tabs.find('#openRequestFormTab').remove();
                $tabs.tabs("refresh");
                containsRequestForm = false;
            }

            var totalOfThis = $('table#selectedProcedures').find('tr#' + id).length;
            $(this).parent().remove();
            var total = $('table#selectedProcedures').find('tr.selectedProcedureItem').length;
            if (total == 0) {
                $('table#selectedProcedures tr#emptyTable').show();
            }

            SortSelectedProcedures();

            if (totalOfThis == 1) {
                $('table#tblProcedureExportFormat').find('input.procedureEFProcedureID[value=' + id + ']').parent().parent().remove();
                SharedOrderFunctions.SortProceduresExportFormats();
            }

            if (useProducts) {
                DeleteProductsByDeletingProcedure(id);
            }

            if (useChecks) {
                DeleteChecksByDeletingProcedure(id);
            }

            GetInvoiceInformation(true);

            SharedOrderFunctions.checkOnDuty();
        });

        var SortSelectedProcedures = function (e) {
            var selected = $('table#selectedProcedures').find('tr.selectedProcedureItem');
            $('span#nrSelectedProcedures').text(selected.length);
            if (selected.length == 0) {
                $('span#nrSelectedProcedures').css('color', '#CD0A0A');
            } else {
                $('span#nrSelectedProcedures').css('color', '#666');
            }
            $.each(selected, function (index, obj) {
                $(selected[index]).find('input.id').attr('name', 'ListProcedureItems[' + index + '].ID');
                $(selected[index]).find('input.modality').attr('name', 'ListProcedureItems[' + index + '].Modality_Text');
                $(selected[index]).find('input.color').attr('name', 'ListProcedureItems[' + index + '].Color');
                $(selected[index]).find('input.code').attr('name', 'ListProcedureItems[' + index + '].Code');
                $(selected[index]).find('input.fullCode').attr('name', 'ListProcedureItems[' + index + '].FullCode');
                $(selected[index]).find('input.radUid').attr('name', 'ListProcedureItems[' + index + '].Radiologist_UID');
                $(selected[index]).find('input.tecUid').attr('name', 'ListProcedureItems[' + index + '].Technician_UID');
                $(selected[index]).find('input.radText').attr('name', 'ListProcedureItems[' + index + '].Radiologist_Text');
                $(selected[index]).find('input.tecText').attr('name', 'ListProcedureItems[' + index + '].Technician_Text');
                $(selected[index]).find('input.roomUID').attr('name', 'ListProcedureItems[' + index + '].Room_UID');
                $(selected[index]).find('input.roomText').attr('name', 'ListProcedureItems[' + index + '].Room_Text');
                $(selected[index]).find('input.description').attr('name', 'ListProcedureItems[' + index + '].Description');
                $(selected[index]).find('input.useOnDuty').attr('name', 'ListProcedureItems[' + index + '].UseOnDuty');
                $(selected[index]).find('input.template').attr('name', 'ListProcedureItems[' + index + '].TemplateUID');
                $(selected[index]).find('input.screeningTemplate').attr('name', 'ListProcedureItems[' + index + '].ScreeningTemplateUID');
                $(selected[index]).find('input.justificationType').attr('name', 'ListProcedureItems[' + index + '].JustificationType');
                $(selected[index]).find('select.statusDrop').attr('name', 'ListProcedureItems[' + index + '].Status_UID');
                $(selected[index]).find('input.substitution').attr('id', 'ListProcedureItems_' + index + '__Substitution');
                $(selected[index]).find('input.substitution').attr('name', 'ListProcedureItems[' + index + '].Substitution');
                $(selected[index]).find('td.substitution').find('input[type="hidden"]').attr('name', 'ListProcedureItems[' + index + '].Substitution');
                $(selected[index]).find('input.procImplementation').attr('name', 'ListProcedureItems[' + index + '].Implementation');
                $(selected[index]).find('input.procPlanned').attr('name', 'ListProcedureItems[' + index + '].DateTimePlanned');
                $(selected[index]).find('input.leftRight').attr('name', 'ListProcedureItems[' + index + '].LeftRight');
            });
        }

        const autocompleteRadiologists = {
            autoFocus: true,
            source: function (request, response) {
                const params = new URLSearchParams({ term: request.term });
                fetch(
                    `/core/radiologist/autocomplete?${ params }`, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                        },
                    }
                ).then(res => {
                    if (res.ok)
                        return res.json();
                }).then(radiologists => {
                    response($.map(radiologists, function (radiologist) {
                        return {
                            label: radiologist.FullName,
                            value: radiologist.FullName,
                            id: radiologist.Id
                        };
                    }));
                });
            },
            minLength: 1,
            select: function (event, ui) {
                $(this).parent().find('input.radUid').val(ui.item.id);
                $(this).parent().find('input.radText').attr('value', ui.item.value);
                if ($('input#CheckRadiologist').is(':checked')) {
                    var selectedProcedures = $('table#selectedProcedures tr.selectedProcedureItem');
                    if (selectedProcedures.first().get(0) === $(this).parent().parent().get(0)) {
                        selectedProcedures.each(function (e) {
                            $(this).find('.radUid').val(ui.item.id);
                            $(this).find('.radUid').attr('value', ui.item.id);
                            $(this).find('.radText').val(ui.item.value);
                            $(this).find('.radText').attr('value', ui.item.value);
                        });
                    }
                }
                GetInvoiceInformation(false, true);
            }
        };

        var autocompleteRooms = {
            autoFocus: true,
            source: function (request, response) {
                $.ajax({
                    url: "/legacy/Json/AutoCompleteRooms",
                    type: "GET",
                    dataType: "json",
                    data: {
                        term: request.term,
                        Site_UID: $('#Site_UID').val()
                    },
                    success: function (data) {
                        response($.map(data, function (item) {
                            return {
                                label: item.FullText,
                                value: item.FullText,
                                id: item.ID
                            };
                        }))
                    }
                })
            },
            minLength: 1,
            select: function (event, ui) {
                $(this).parent().find('input.roomUID').val(ui.item.id);
                $(this).parent().find('input.roomText').attr('value', ui.item.value);

                var row = $(this).parent().parent();

                $.ajax({
                    url: "/legacy/Json/GetDefaultRadiologistForRoom",
                    type: "GET",
                    dataType: "json",
                    data: {
                        Room_UID: ui.item.id
                    },
                    success: function (data) {
                        var radUid = data.ID;
                        var radText = data.FullName;

                        var currentRadUid = row.find('td.radiologist input.radUid').val();
                        var currentRadText = row.find('td.radiologist input.radText').val();

                        if (shouldApplyHallDefaultRadiologist(currentRadUid, currentRadText) && $.trim(radText) != "") {
                            row.find('td.radiologist').find('input.radUid').val(radUid);
                            row.find('td.radiologist').find('input.radUid').attr('value', radUid);
                            row.find('td.radiologist').find('input.radText').val(radText);
                            row.find('td.radiologist').find('input.radText').attr('value', radText);
                        }
                        if (useChecks) {
                            if ($('#GroupChecks').is(':checked')) {
                                deGroupChecks();
                                groupChecks();
                            }
                        }
                    }
                })

                if ($('input#CheckRoom').is(':checked')) {
                    var selectedProcedures = $('table#selectedProcedures tr.selectedProcedureItem');
                    if (selectedProcedures.first().get(0) === $(this).parent().parent().get(0)) {
                        selectedProcedures.each(function (e) {
                            $(this).find('.roomUID').val(ui.item.id);
                            $(this).find('.roomUID').attr('value', ui.item.id);
                            $(this).find('.roomText').val(ui.item.value);
                            $(this).find('.roomText').attr('value', ui.item.value);
                        });
                    }
                }
            },
            change: function (event, ui) {
                if (!ui.item) {
                    $(this).parent().find('input.roomUID').val("");
                    $(this).parent().find('input.roomText').val("");
                }
            }
        };

        var autocompleteTechnicians = {
            autoFocus: true,
            source: function (request, response) {
                $.ajax({
                    url: "/legacy/Json/AutoCompleteTechnicians",
                    type: "GET",
                    dataType: "json",
                    data: {
                        term: request.term
                    },
                    success: function (data) {
                        response($.map(data, function (item) {
                            return {
                                label: item.FullText,
                                value: item.FullText,
                                id: item.ID
                            };
                        }))
                    }
                })
            },
            minLength: 1,
            select: function (event, ui) {
                $(this).parent().find('input.tecUid').val(ui.item.id);
                $(this).parent().find('input.tecText').attr('value', ui.item.value);
                if ($('input#CheckTechnician').is(':checked')) {
                    var selectedProcedures = $('table#selectedProcedures tr.selectedProcedureItem');
                    if (selectedProcedures.first().get(0) === $(this).parent().parent().get(0)) {
                        selectedProcedures.each(function (e) {
                            $(this).find('.tecUid').val(ui.item.id);
                            $(this).find('.tecUid').attr('value', ui.item.id);
                            $(this).find('.tecText').val(ui.item.value);
                            $(this).find('.tecText').attr('value', ui.item.value);
                        });
                    }
                }
            },
            change: function (event, ui) {
                if (!ui.item) {
                    $(this).parent().find('input.tecUid').val("");
                    $(this).parent().find('input.tecText').val("");
                }
            }
        };

        $('input#CheckRadiologist').on('change', function (e) {
            if ($('input#CheckRadiologist').is(':checked')) {
                $('table#selectedProcedures tr.selectedProcedureItem').each(function (e) {
                    SetDefaultRadiologist($(this));
                });
            }

            GetInvoiceInformation();

        });

        $('input#CheckTechnician').on('change', function (e) {
            if ($('input#CheckTechnician').is(':checked')) {
                $('table#selectedProcedures tr.selectedProcedureItem').each(function (e) {
                    SharedOrderFunctions.SetDefaultTechnician($(this), viewbagDefaultTechnicianUID);
                });
            }
        });

        $('input#CheckRoom').on('change', function (e) {
            if ($('input#CheckRoom').is(':checked')) {
                $('table#selectedProcedures tr.selectedProcedureItem').each(function (e) {
                    SharedOrderFunctions.SetDefaultRoom($(this), false, viewbagDefaultRoomUID, viewbagDefaultRoomText);
                });
            }
        });

        var defaultRadUid = viewbagDefaultRadiologistUID;
        var defaultRadText = viewbagDefaultRadiologistText;
        var SetDefaultRadiologist = function (row) {
            var radUid;
            var radText;
            if ($('input#CheckRadiologist').is(':checked')) {
                radUid = $('table#selectedProcedures tr.selectedProcedureItem').first().find('input.radUid').val();
                radText = $('table#selectedProcedures tr.selectedProcedureItem').first().find('input.radText').val();
                if (radUid == "") {
                    radUid = defaultRadUid;
                    radText = defaultRadText;
                }
            } else {
                radUid = defaultRadUid;
                radText = defaultRadText;
            }

            row.find('.radUid').val(radUid);
            row.find('.radUid').attr('value', radUid);
            row.find('.radText').val(radText);
            row.find('.radText').attr('value', radText);
        }

        

        var SetLabels = function () {
            if ($('#Site_UID').length > 0) {
                $.ajax({
                    url: "/legacy/Orders/GetLabelsAddForSite",
                    type: "GET",
                    dataType: "html",
                    data: {
                        Site_UID: $('#Site_UID').val()
                    },
                    async: true,
                    success: function (data) {
                        if (data) {
                            $('div#labelsDiv').html(data);
                        }
                    }
                });
            }
        }

        var SetME = function () {
            if ($('#Site_UID').length > 0) {
                $.ajax({
                    url: "/legacy/Json/GetMEForSite",
                    type: "GET",
                    dataType: "json",
                    data: {
                        Site_UID: $('#Site_UID').val()
                    },
                    async: true,
                    success: function (data) {
                        if (data) {
                            $('#Idgkb').val(data.ME);
                        }
                    }
                });
            }
        }

        $('#Site_UID').on('change', function (e) {
            $('table#selectedProcedures tr.selectedProcedureItem').each(function (e) {
                SharedOrderFunctions.SetDefaultRoom($(this), false, viewbagDefaultRoomUID, viewbagDefaultRoomText);
            });
            SetME();
            SetLabels();
        });

        $('#subFieldProcedures').keypress(function (e) {
            if (e.keyCode == 13) {
                return false;
            }
        });

        $('#tblOrderExportFormats').on('click', 'td.delete', function (e) {
            $(this).parent().remove();
            $('#DropOrderExportFormats').append($('<option></option>').val($(this).parent().find('input.orderEFID').val() + "_" + $(this).parent().find('input.orderEFOrderTriggerStatus').val() + "_" + $(this).parent().find('input.orderEFReportTriggerStatus').val()).html( $(this).parent().find('input.orderEFName').val() + ' | ' + $(this).parent().find('input.triggerStatus').val()));
            SharedOrderFunctions.sortOrderExportFormats();
        });

        $('#tblOrderExportFormatsAdd td.add').on('click', function (e) {
            var val = $('#DropOrderExportFormats').val();
            if (val != "-1") {
                var text = $('#DropOrderExportFormats option:selected').text();
                var amount = $(this).parent().find('input.orderEFAmount').spinner("value");
                var triggerStatus = text.substring(text.indexOf("|")+1);

                var efID = val.split("_")[0];
                var orderTriggerStatusID = val.split("_")[1];
                var reportTriggerStatusID = val.split("_")[2];

                var toAppend = '<tr class="orderExportFormatRow"><td>' + text.substring(0, text.indexOf("|")-1);
                toAppend += '<input class="orderEFName" type="hidden" value="' + text.substring(0, text.indexOf("|")-1) + '" name="ListOrderExportFormat[0].Name" />';
                toAppend += '<input class="orderEFID" type="hidden" value="' + efID + '" name="ListOrderExportFormat[0].ID" />';
                toAppend += '<input class="orderEFPartial" type="hidden" value="false" name=ListOrderExportFormat[0].UseInPartial />';
                toAppend += '<td><input class="orderEFAmount spinner" value="' + amount + '" name="ListOrderExportFormat[0].Amount" /></td>';
                toAppend += '<td>' + triggerStatus + '<input type="hidden" class="triggerStatus" name="ListOrderExportFormat[0].TriggerStatus" value="' + triggerStatus + '" />';
                toAppend += '<input type="hidden" class="orderEFOrderTriggerStatus" name="ListOrderExportFormat[0].OrderTriggerStatus_UID" value="' + orderTriggerStatusID + '" />';
                toAppend += '<input type="hidden" class="orderEFReportTriggerStatus" name="ListOrderExportFormat[0].ReportTriggerStatus_UID" value="' + reportTriggerStatusID + '" />';
                toAppend += '</td><td class="delete">resourceDelete</td></tr>';
                $('#tblOrderExportFormats').append(toAppend);
                $('.spinner').spinner(spinnerOptions);
                $('.spinner').ForceNumericOnly();
                $('#DropOrderExportFormats option[value="' + val + '"]').remove();
                SharedOrderFunctions.sortOrderExportFormats();
            }
        });

        $('#tblPhysExportFormatsApp').on('click', 'td.delete', function (e) {
            $(this).parent().remove();
            SharedOrderFunctions.SortPhysExportFormats('App');
        });

        $('#tblPhysExportFormatsAppCC').on('click', 'td.delete', function (e) {
            $(this).parent().remove();
            SharedOrderFunctions.SortPhysExportFormats('AppCC');
        });

        $('#tblPhysExportFormatsAppCC2').on('click', 'td.delete', function (e) {
            $(this).parent().remove();
            SharedOrderFunctions.SortPhysExportFormats('AppCC2');
        });

        if ($('input#Applicant_UID').val() != "0") {
            SharedOrderFunctions.setActiveApplicantDetailAndRemoveMenuOptions(true, "App", viewbagUniquePrefix);
        }

        if ($('input#Applicant_CC_UID').val() != "0") {
            SharedOrderFunctions.setActiveApplicantDetailAndRemoveMenuOptions(true, "AppCC", viewbagUniquePrefix);
        }

        if ($('input#Applicant_CC_2_UID').val() != "0") {
            SharedOrderFunctions.setActiveApplicantDetailAndRemoveMenuOptions(true, "AppCC2", viewbagUniquePrefix);
        }

        $('.spinner').spinner(spinnerOptions);
        $('.spinner').ForceNumericOnly();
        $('.spinner2').spinner(spinnerOptions2);
        $('.spinner2').ForceNumericOnly();
        $('.tecText').autocomplete(autocompleteTechnicians);
        $('.radText').autocomplete(autocompleteRadiologists);
        $('.roomText').autocomplete(autocompleteRooms);

        SortSelectedProcedures();
        SharedOrderFunctions.SortPhysExportFormats('App');
        SharedOrderFunctions.SortPhysExportFormats('AppCC');
        SharedOrderFunctions.SortPhysExportFormats('AppCC2');
        SharedOrderFunctions.SortProceduresExportFormats();

        $("#PopupPatientHealthInsuranceSpecificSearch").change(function () {

            $('#PopupPatientHealthInsuranceText').autocomplete("search");
        });

        $('#PopupPatientHealthInsuranceText').autocomplete({
            autoFocus: false,
            source: function (request, response) {
                $.ajax({
                    url: "/legacy/Json/AutoCompleteHealthInsurances",
                    type: "GET",
                    dataType: "json",
                    data: {
                        term: request.term,
                        specific: $('#PopupPatientHealthInsuranceSpecificSearch').is(':checked')
                    },
                    success: function (data) {
                        if (data.length == 0) {
                            $('#PopupPatientHealthInsuranceID').val("0");
                            $('#PopupPatientHealthInsuranceText').css('border-color', '#CD0A0A');
                        }
                        response($.map(data, function (item) {
                            return {
                                label: item.FullText,
                                value: item.FullText,
                                id: item.ID
                            };
                        }))
                    }
                })
            },
            minLength: 2,
            select: function (event, ui) {
                $('#PopupPatientHealthInsuranceID').val(ui.item.id);
                $('#PopupPatientHealthInsuranceText').attr('value', ui.item.value);
                $('#PopupPatientHealthInsuranceText').css('border-color', '#999');
            }
        });

        if (!BelgianLayout) {
            $tabs.find('#openInvoiceTab').remove();
            $tabs.tabs("refresh");
        }

        $('div#invoiceTab').on('change', 'input#OnDuty, ' +
            'input#WIGW,' +
            ' input#PatientGMD,' +
            ' input#AmbulantHospitalized,' +
            ' input#FreeOfContribution,' +
            ' input#FreeOfCharge,' +
            ' input#InvoiceCumulRules,' +
            ' input#InvoiceSupplement,' +
            ' input#InvoiceClaustrophobia,' +
            ' input#InvoiceCertificate'
            , function (e) {
                e.stopImmediatePropagation();

                GetInvoiceInformation(true);
            }
        );

        var SetInvoiceSituationParameters = function (value) {
            switch (value) {
                default:
                //NORMAL
                case "1":
                    $('div#invoiceTab div#invoiceCompany').hide();
                    $('div#invoiceTab div#invoiceEmployer').hide();
                    $('div#invoiceTab div#invoiceOnDuty label, div#invoiceTab div#invoiceOnDuty input').show();
                    $('div#invoiceTab div#invoiceFreeOfCharge label, div#invoiceTab div#invoiceFreeOfCharge input').show();
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField').show();
                    $('div#invoiceTab div#invoiceInvoiceCertificate').hide();
                    $('div#invoiceTab div#invoiceInvoiceCertificate input').prop('checked', true);
                    $('div#invoiceTab div#invoiceInvoiceReferenceNumber').hide();
                    $('div#invoiceTab div#invoiceInvoiceReferenceDateTime').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules input').prop('checked', true);
                    companyFilled = false;
                    $('div#invoiceTab div#invoiceCompany span.infoIcon').hide();

                    break;
                //MISC
                case "2":
                    $('div#invoiceTab div#invoiceCompany').hide();
                    $('div#invoiceTab div#invoiceEmployer').hide();
                    $('div#invoiceTab div#invoiceOnDuty label, div#invoiceTab div#invoiceOnDuty input').show();
                    $('div#invoiceTab div#invoiceFreeOfCharge label, div#invoiceTab div#invoiceFreeOfCharge input').hide();
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField').hide();
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="1"]').prop('checked', true).parent().show();
                    invoiceMethod = 1;
                    $('div#invoiceTab div#invoiceInvoiceCertificate').hide();
                    $('div#invoiceTab div#invoiceInvoiceCertificate input').prop('checked', false);
                    $('div#invoiceTab div#invoiceInvoiceReferenceNumber').hide();
                    $('div#invoiceTab div#invoiceInvoiceReferenceDateTime').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules input').prop('checked', true);
                    companyFilled = false;
                    $('div#invoiceTab div#invoiceCompany span.infoIcon').hide();

                    break;
                //SOCIAL WELFARE
                case "3":
                    $('div#invoiceTab div#invoiceCompany').show();
                    $('div#invoiceTab div#invoiceEmployer').hide();
                    $('div#invoiceTab div#invoiceCompany span.required').show();
                    $('div#invoiceTab div#invoiceOnDuty label, div#invoiceTab div#invoiceOnDuty input').show();
                    $('div#invoiceTab div#invoiceFreeOfCharge label, div#invoiceTab div#invoiceFreeOfCharge input').hide();
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField').hide();
                    if (invoiceMethod > 2) {
                        $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="1"]').prop('checked', true);
                        invoiceMethod = 1;
                    }
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="1"]').parent().show();
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="2"]').parent().show();

                    $('div#invoiceTab div#invoiceInvoiceCertificate').show();
                    $('div#invoiceTab div#invoiceInvoiceCertificate input').prop('checked', true);
                    $('div#invoiceTab div#invoiceInvoiceReferenceNumber').hide();
                    $('div#invoiceTab div#invoiceInvoiceReferenceDateTime').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules input').prop('checked', true);
                    companyFilled = false;
                    $('div#invoiceTab div#invoiceCompany span.infoIcon').hide();

                    break;
                //EXPERTISE
                case "4":
                    $('div#invoiceTab div#invoiceCompany').show();
                    $('div#invoiceTab div#invoiceEmployer').show();
                    $('div#invoiceTab div#invoiceCompany span.required').show();
                    $('div#invoiceTab div#invoiceOnDuty label, div#invoiceTab div#invoiceOnDuty input').show();
                    $('div#invoiceTab div#invoiceInvoiceCertificate').hide();
                    $('div#invoiceTab div#invoiceInvoiceCertificate input').prop('checked', false);
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField').hide();
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="1"]').prop('checked', true).parent().show();
                    invoiceMethod = 1;
                    $('div#invoiceTab div#invoiceFreeOfCharge label, div#invoiceTab div#invoiceFreeOfCharge input').show();
                    $('div#invoiceTab div#invoiceInvoiceReferenceNumber').show();
                    $('div#invoiceTab div#invoiceInvoiceReferenceDateTime').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules input').prop('checked', false);
                    companyFilled = false;
                    $('div#invoiceTab div#invoiceCompany span.infoIcon').hide();

                    break;
                //INSURANCE COMPANY
                case "5":
                    $('div#invoiceTab div#invoiceCompany').show();
                    $('div#invoiceTab div#invoiceEmployer').show();
                    $('div#invoiceTab div#invoiceCompany span.required').show();
                    $('div#invoiceTab div#invoiceOnDuty label, div#invoiceTab div#invoiceOnDuty input').show();
                    $('div#invoiceTab div#invoiceInvoiceCertificate').hide();
                    $('div#invoiceTab div#invoiceInvoiceCertificate input').prop('checked', false);
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField').hide();
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="1"]').prop('checked', true).parent().show();
                    invoiceMethod = 1;
                    $('div#invoiceTab div#invoiceInvoiceReferenceNumber').show();
                    $('div#invoiceTab div#invoiceInvoiceReferenceDateTime').show();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules input').prop('checked', true);
                    companyFilled = false;
                    $('div#invoiceTab div#invoiceCompany span.infoIcon').hide();

                    break;
                //OTHER
                case "6":
                    $('div#invoiceTab div#invoiceCompany').show();
                    $('div#invoiceTab div#invoiceCompany span.required').hide();
                    $('div#invoiceTab div#invoiceOnDuty label, div#invoiceTab div#invoiceOnDuty input').show();
                    $('div#invoiceTab div#invoiceInvoiceCertificate').show();
                    $('div#invoiceTab div#invoiceInvoiceCertificate input').prop('checked', true);
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField').hide();
                    if (invoiceMethod > 2) {
                        $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="1"]').prop('checked', true);
                        invoiceMethod = 1;
                    }
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="1"]').parent().show();
                    $('div#invoiceTab div#invoiceInvoicePaymentMethod div.radioField input[value="2"]').parent().show();

                    $('div#invoiceTab div#invoiceInvoiceReferenceNumber').hide();
                    $('div#invoiceTab div#invoiceInvoiceReferenceDateTime').hide();
                    $('div#invoiceTab div#invoiceInvoiceCumulRules').show();

                    $('div#invoiceTab div#invoiceCompany span.infoIcon').show();

                    break;
            }
        }

        SetInvoiceSituationParameters($('select#InvoiceSituation_UID').val());

        $('div#invoiceTab').on('change', 'select#InvoiceSituation_UID', function (e) {
            SetInvoiceSituationParameters($(this).val());
            invoiceMethod = $('input[name="InvoicePaymentMethod"]:checked').val();
            if (invoiceMethod == 2 || invoiceMethod == 4) {
                $('input#InvoiceCertificate').prop('checked', true);
                $('div#invoiceInvoiceCertificate').hide();
            } else {
                if ($(this).val() == "3" || $(this).val() == "6") {
                    $('input#InvoiceCertificate').prop('checked', true);
                    $('div#invoiceInvoiceCertificate').show();
                }
            }
            SetHealthInsuranceParameters(invoiceMethod);
            $('input#InvoiceCompany_Text').val("");
            $('input#InvoiceCompany_UID').val("0");

            GetInvoiceInformation(true);
        });

        $('div#invoiceTab').on('click', 'span.refreshAmountPatient', function (e) {
            GetInvoiceInformation(true);
        });

        $('div#invoiceTab').on('click', 'span.refreshTotalAmount', function (e) {
            GetInvoiceInformation(true);
        });

        $('form#addOrderForm').on('submit', function (e) {
            if ($('div#invoiceTab input.cleanInput').is(':focus')) {
                e.preventDefault();
                return false;
            }
        });

        $('#scanOrder').tooltip({
            tooltipClass: 'jqueryTooltip',
            content: function () {
                return resourceScanOrderValidationMessage.toUpperCase();
            },
            disabled: true,
            position: {
                my: "left top",
                at: "left bottom"
            },
            close: function (event, ui) {
                $('.jqueryTooltip').remove();
            },
            show: function (event, ui) {
                $('.jqueryTooltip').remove();
            }
        });

        let validateOrderImplementationAddAjax;
        $('input#DateOfImplementation').bind('input', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            SharedOrderFunctions.validateOrderImplementationDate($(this), validateOrderImplementationAddAjax, useProducts, modelPatientID);
        });



        let validateProcImplementationAddAjax;
        $('body').on('keyup', '.procImplementation', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            SharedOrderFunctions.validateProcedureImplementationDate($(this), validateProcImplementationAddAjax);
        });

        $('div#invoiceTab').on('change', 'input[name=InvoicePaymentMethod]:radio', function (e) {
            e.stopImmediatePropagation();
            $('input[type=radio][name=InvoicePaymentMethod]').removeAttr('checked');
            $('input[type=radio][name=InvoicePaymentMethod]').removeProp('checked');
            $(this).attr('checked', 'checked');
            $(this).prop('checked', true);

            invoiceMethod = $('input[name="InvoicePaymentMethod"]:checked').val();
            if (invoiceMethod == 2 || invoiceMethod == 4) {
                $('input#InvoiceCertificate').prop('checked', false);
                $('div#invoiceInvoiceCertificate').hide();
            } else {
                var selectedInvoice = $('select#InvoiceSituation_UID').val();
                if (selectedInvoice == "3" || selectedInvoice == "6") {
                    $('input#InvoiceCertificate').prop('checked', true);
                    $('div#invoiceInvoiceCertificate').show();
                }
            }
            SetHealthInsuranceParameters(invoiceMethod);
            GetInvoiceInformation(true);
        });

        $('#InvoiceCompany_Text').autocomplete({
            autoFocus: false,
            source: function (request, response) {
                $.ajax({
                    url: "/legacy/Json/AutoCompleteCompany",
                    type: "GET",
                    dataType: "json",
                    data: {
                        term: request.term,
                        invoiceSituation_UID: $('select#InvoiceSituation_UID').val()
                    },
                    success: function (data) {
                        if (data.length == 0) {
                            $('#InvoiceCompany_UID').val("0");
                            $('a#showCompanyDetail' + viewbagUniquePrefix).addClass('inActive');
                            $('a#removeCompany' + viewbagUniquePrefix).addClass('inActive');
                            $('#InvoiceCompany_Text').css('border-color', '#CD0A0A');
                        }
                        response($.map(data, function (item) {
                            return {
                                label: item.FullText,
                                value: item.FullText,
                                id: item.ID
                            };
                        }))
                    }
                })
            },
            minLength: 1,
            select: function (event, ui) {
                $('#InvoiceCompany_UID').val(ui.item.id);
                $('a#showCompanyDetail' + viewbagUniquePrefix).removeClass('inActive');
                $('a#removeCompany' + viewbagUniquePrefix).removeClass('inActive');
                $('#InvoiceCompany_Text').attr('value', ui.item.value);
                $('#InvoiceCompany_Text').css('border-color', '#999');
                if ($('select#InvoiceSituation_UID').val() == 6) {
                    companyFilled = true;

                    GetInvoiceInformation();
                }
            }
        });

        $('#divFindCompany' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: "#contentView",
            title: $("<div/>").html(resourcedialogFindCompany).text()
        });

        $('a#showCompanyDialog' + viewbagUniquePrefix).on('click', function (e) {
            $('#divFindCompany' + viewbagUniquePrefix).dialog("open");
        });

        $('button#btnCloseCompanyDialog' + viewbagUniquePrefix).on('click', function (e) {
            $('#divFindCompany' + viewbagUniquePrefix).dialog("close");
        });

        $('#txtFindCompanyName' + viewbagUniquePrefix).on('keyup', function (e) {
            findCompanies();
        });
        $('#txtFindCompanyAddress' + viewbagUniquePrefix).on('keyup', function (e) {
            findCompanies();
        });

        var findCompanies = function (e) {
            $.ajax({
                type: 'POST',
                url: '/legacy/Orders/FindCompaniesForGrid',
                data: {
                    Name: $('#txtFindCompanyName' + viewbagUniquePrefix).val(),
                    Address: $('#txtFindCompanyAddress' + viewbagUniquePrefix).val(),
                    InvoiceSituation_UID: $('select#InvoiceSituation_UID').val()
                },
                dataType: 'json',
                success:
                    function (data) {
                        $('#gridFindCompany' + viewbagUniquePrefix + ' tr:not(.tableHeader)').remove();
                        $("#btnLoadSelectedCompany" + viewbagUniquePrefix).attr("disabled", true);
                        if (data.items.length > 0) {
                            $.each(data.items, function (e) {
                                $('#gridFindCompany' + viewbagUniquePrefix).append('<tr class="record"><td class="rowId">' + this.ID + '</td><td class="rowName">' + this.FullName + '</td><td class="rowAddress">' + this.Address + '</td></tr>');
                            });
                        } else {
                            $('#gridFindCompany' + viewbagUniquePrefix).append('<tr class="noRecords"><td colspan="3">resourceNoCompaniesFound</td></tr>');
                        }
                    }
            });
        }

        $('#gridFindCompany' + viewbagUniquePrefix).on('click', 'tr.record', function (e) {
            $(this).parent().find('tr.focus').removeClass('focus');
            $(this).addClass('focus');
            $("#btnLoadSelectedCompany" + viewbagUniquePrefix).removeAttr("disabled");
        });

        $('#gridFindCompany' + viewbagUniquePrefix).on('dblclick', 'tr.record', function (e) {
            $(this).parent().find('tr.focus').removeClass('focus');
            $(this).addClass('focus');
            $("#btnLoadSelectedCompany" + viewbagUniquePrefix).removeAttr("disabled");
            LoadSelectedCompany();
        });

        $('#btnLoadSelectedCompany' + viewbagUniquePrefix).on('click', function (e) {
            if ($('select#InvoiceSituation_UID').val() == 6) {
                companyFilled = true;

                GetInvoiceInformation();
            }
            LoadSelectedCompany();
        });

        var LoadSelectedCompany = function (e) {
            var id = $('#gridFindCompany' + viewbagUniquePrefix).find('tr.focus').find('td.rowId').html();
            var name = $('#gridFindCompany' + viewbagUniquePrefix).find('tr.focus').find('td.rowName').html();
            var address = $('#gridFindCompany' + viewbagUniquePrefix).find('tr.focus').find('td.rowAddress').html();
            $('#divFindCompany' + viewbagUniquePrefix).dialog("close");
            $('input#InvoiceCompany_Text').attr('value', name + " - " + address);
            $('input#InvoiceCompany_Text').val(name + " - " + address);
            $('input#InvoiceCompany_UID').attr('value', id);
            $('a#showCompanyDetail' + viewbagUniquePrefix).removeClass('inActive');
            $('a#removeCompany' + viewbagUniquePrefix).removeClass('inActive');
            $('#InvoiceCompany_Text').css('border-color', '#999');
        }

        $('a#removeCompany' + viewbagUniquePrefix).on('click', function (e) {
            if ($(this).hasClass('inActive')) {
                e.preventDefault();
            } else {
                $('input#InvoiceCompany_UID').val("0");
                $('input#InvoiceCompany_Text').val("");
                $('input#InvoiceCompany_Text').attr('value', "");
                $(this).addClass('inActive');
                $('a#showCompanyDetail' + viewbagUniquePrefix).addClass('inActive');
            }
            if ($('select#InvoiceSituation_UID').val() == 6) {
                companyFilled = false;

                GetInvoiceInformation();
            }
        });

        $('a#showCompanyDetail' + viewbagUniquePrefix).on('click', function (e) {
            if ($(this).hasClass('inActive')) {
                e.preventDefault();
            } else {
                var id = $('input#InvoiceCompany_UID').val();
                useFilingCabinet('/Companies/Detail/' + id);
            }
        });

        $('#InvoiceCompany_Text').on('keyup', function (e) {
            if ($('select#InvoiceSituation_UID').val() == 6) {
                if ($(this).val() == "") {
                    companyFilled = false;

                    GetInvoiceInformation();
                }
            }
        });

        var SetHealthInsuranceParameters = function (paymentMethod) {
            if (paymentMethod == 2 || paymentMethod == 4) {
                $('#healthInsuranceParams span.none').addClass('noneRequired');
            } else {
                $('#healthInsuranceParams span.none').removeClass('noneRequired');
            }
        }


        $('.infoHoverPopup').hide();

        $('#dialogConfirmInvoice' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#addOrderForm',
            beforeClose: function () {
                var close = SharedOrderFunctions.ValidatePaymentPlan();
                if (!close) {
                    var validation = $('#dialogConfirmInvoice' + viewbagUniquePrefix).find('span.validation');
                    validation.text(resourceInvalidPaymentPlan);
                    validation.show();
                }

                return close;
            },
            title: $("<div/>").html(resourceConfirmInvoice).text()
        });

        $('input#AddPaymentInput').ForcePositiveNegativeNumericOnly();
        $('input#AddPaymentPlanInput').ForcePositiveNegativeNumericOnly();

        var SortPaymentItems = function () {
            var payments = $('#donePayments table.donePayment').find('.paymentRow');
            $.each(payments, function (index, obj) {
                $(payments[index]).find('input.hiddenDonePaymentValue').attr('name', 'ListPaymentItem[' + index + '].Amount');
                $(payments[index]).find('input.hiddenDonePaymentMethod').attr('name', 'ListPaymentItem[' + index + '].Method');
            });
        }

        $('input#confirmInvoiceButton').on('click', function (e) {
            SharedOrderFunctions.ShowConfirmInvoiceDialog();
        });

        $('#btnCloseConfirmInvoice' + viewbagUniquePrefix).on('click', function (e) {
            if (SharedOrderFunctions.ValidatePaymentPlan()) {
                $('#dialogConfirmInvoice' + viewbagUniquePrefix).dialog('close');
            } else {
                var validation = $('#dialogConfirmInvoice' + viewbagUniquePrefix).find('span.validation');
                validation.text(resourceInvalidPaymentPlan);
                validation.show();
                return false;
            }
        });

        $('input#AddPaymentInput').on('keypress', function (e) {
            if (e.keyCode == 13) {
                $('span#btnAddPayment').trigger('click');
                return false;
            }
        });

        $('input#AddPaymentPlanInput').on('keypress', function (e) {
            if (e.keyCode == 13) {
                $('span#btnAddPaymentPlan').trigger('click');
                return false;
            }
        });

        $('input#AddPaymentPlanDate').on('keypress', function (e) {
            if (e.keyCode == 13) {
                $('span#btnAddPaymentPlan').trigger('click');
                return false;
            }
        });

        $('select#PayedByMethod').on('keypress', function (e) {
            if (e.keyCode == 13) {
                $('span#btnAddPayment').trigger('click');
                return false;
            }
        });

        $('dd#donePayments table.donePayment').on('click', 'td.delete', function (e) {
            $(this).parent().remove();
            SharedOrderFunctions.CalculateInvoiceAmounts();
            SortPaymentItems();
        });

        $('span#btnAddPayment').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            var dialog = $('#dialogConfirmInvoice' + viewbagUniquePrefix);
            var validation = dialog.find('span.validation');
            var amount = $('input#AddPaymentInput').val();

            if (!$.isNumeric(amount)) {
                validation.text(resourceErrorValidAmount);
                validation.show();
                return false;
            }

            var amountNumber = parseFloat(amount, 10);

            var selectedMethod = $("#PayedByMethod option:selected").text();
            var selectedMethodID = $("#PayedByMethod").val();

            var donePayments = $('dd#donePayments table.donePayment');

            var lineToAdd = '<tr class="paymentRow newPaymentRow"><td>&euro; ' + amountNumber.toFixed(2).toString();
            lineToAdd += '<input name="ListPaymentItem[0].Amount" type="hidden" class="hiddenDonePaymentValue" value="' + amountNumber.toFixed(2).toString() + '"></td>';
            lineToAdd += '<td>' + selectedMethod + '<input name="ListPaymentItem[0].Method" type="hidden" class="hiddenDonePaymentMethod" value="' + selectedMethodID + '"></td>';
            lineToAdd += '<td class="delete" title="' + resourceDelete + '">&nbsp;</td></tr>';

            donePayments.append(lineToAdd);

            SharedOrderFunctions.CalculateInvoiceAmounts();
            SortPaymentItems();
        });

        $('dd#donePaymentsPlan table.donePaymentPlan').on('click', 'td.delete', function (e) {
            var dialog = $('#dialogConfirmInvoice' + viewbagUniquePrefix);
            $(this).parent().remove();
            dialog.find('.toAddPaymentPlan').show();
            SharedOrderFunctions.CalculateInvoiceAmounts();
            SharedOrderFunctions.SortPaymentPlanItems();
        });

        $("#PayedByMethod").change(function() {
            SharedOrderFunctions.CalculateInvoiceAmounts();
        });

        $('span#btnAddPaymentPlan').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            var dialog = $('#dialogConfirmInvoice' + viewbagUniquePrefix);
            var validation = dialog.find('span.validation');
            var amount = parseFloat($('input#AddPaymentPlanInput').val());
            var dueDate = $('input#AddPaymentPlanDate').val();

            if (!$.isNumeric(amount) || amount <= 0) {
                validation.text(htmlDecode(resourceErrorValidAmount));
                validation.show();
                return false;
            }

            var dueDateMoment = moment(dueDate, "DD/MM/YYYY", true);
            if (dueDateMoment == null || !dueDateMoment.isValid()) {
                validation.text(resourceInvalidDueDate);
                validation.show();
                return false;
            }

            var donePayments = $('dd#donePaymentsPlan table.donePaymentPlan');

            var paymentPlanLength = $(".donePaymentPlan tr").length  - 1;
            var lineToAdd = '<tr class="paymentPlanRow"><td>&euro; <span class="donePaymentPlanValue">' + amount.toFixed(2) + '</span>';
            lineToAdd += '<input name="ListPaymentPlanItem[' + paymentPlanLength + '].Amount" type="hidden" class="hiddenDonePaymentPlanValue" value="' + amount.toFixed(2) + '"></td>';
            lineToAdd += '<td><span class="donePaymentPlanDueDate">' + dueDate + '</span>';
            lineToAdd += '<input name="ListPaymentPlanItem[' + paymentPlanLength + '].DueDate" type="hidden" class="hiddenDonePaymentPlanDueDate" value="' + dueDate + '"></td>';
            lineToAdd += '<td class="delete" title="' + resourceDelete + '">&nbsp;</td></tr>';

            donePayments.append(lineToAdd);

            SharedOrderFunctions.CalculateInvoiceAmounts();
            SharedOrderFunctions.SortPaymentPlanItems();
        });

        $('#btnConfirmInvoice' + viewbagUniquePrefix).on('click', function (e) {
            SharedOrderFunctions.ConfirmInvoice(viewbagUniquePrefix);
        });

        $('#btnConfirmPrepayment' + viewbagUniquePrefix).on('click', function (e) {
            if (SharedOrderFunctions.ValidatePaymentPlan()) {
                $('input#ConfirmInvoice').val("false");
                $('input#ConfirmInvoice').attr('value', "false");
                $('input#ConfirmPrepayment').val("true");
                $('input#ConfirmPrepayment').attr('value', "true");

                $('#btnConfirmPrepayment' + viewbagUniquePrefix).prop('disabled', true);

                SharedOrderFunctions.ConfirmInvoiceFunctionality();
            } else {
                var validation = $('#dialogConfirmInvoice' + viewbagUniquePrefix).find('span.validation');
                validation.text(resourceInvalidPaymentPlan);
                validation.show();
                return false;
            }
        });


        // TODO
        var checkIfOkToSave = function (confirmInvoice) {
            $('#loading').show();

            if(!SharedOrderFunctions.saveChecker.canBeSaved())
                return;

            const amountScans = $('.scannedOrderHolder' + '').length;

            if (viewbagShowScanWarning == 'True' && amountScans == 0) {
                gConfirmInvoice = confirmInvoice;
                $('#dialogScanWarning' + viewbagUniquePrefix).dialog('open');
            } else {
                saveOrder(confirmInvoice);
            }
        }

        var saveOrder = function (confirmInvoice) {
            if (confirmInvoice) {
                var dialog = $('#dialogConfirmInvoice' + viewbagUniquePrefix);
                var validation = dialog.find('span.validation');
                validation.hide();
                validation.text("");

                if ($('.invoiceCertificateNumber').is(':visible')) {
                    var number = $('input#InvoiceCertificateNumber').val();
                    if (!$.isNumeric(number)) {
                        validation.text(resourceErrorValidNumber);
                        validation.show();

                        $('#btnConfirmInvoice' + viewbagUniquePrefix).prop('disabled', false);
                        $('#btnConfirmPrepayment' + viewbagUniquePrefix).prop('disabled', false);

                        return false;
                    }
                }

                $('form#addOrderForm').submit();
            } else {
                if (containsRequestForm) {
                    if (viewbagEnforceValidateRequestform == 'True') {
                        if (!ValidateRequestFormInputFields(false)) {
                            $('a[href="#requestFormTabContent"]').trigger('click');
                            $("#request #validationdiv")[0].scrollIntoView(true);
                            return;
                        }
                    } else {
                        if (!ValidateRequestFormInputFieldsNonRequired()) {
                            $('a[href="#requestFormTabContent"]').trigger('click');
                            $("#request #validationdiv")[0].scrollIntoView(true);
                            return;
                        }
                    }
                }

                $('input#ConfirmInvoice').val("false");
                $('input#ConfirmInvoice').attr('value', "false");
                $('input#ConfirmPrepayment').val("false");
                $('input#ConfirmPrepayment').attr('value', "false");

                if (modelPatientTemporary == "True") {
                    SharedOrderFunctions.FindPatientsToMergeForOrder(viewbagUniquePrefix, modelPatientID);
                    $('#divMergePatient' + viewbagUniquePrefix).dialog('open');
                } else {
                    $('form#addOrderForm').submit();
                }
            }
        }


        $('#btnAddOrder').on('click', function (e) {
            SharedOrderFunctions.saveChecker.queueSave(() => checkIfOkToSave(false));
        });

        SortPaymentItems();
        SharedOrderFunctions.SortPaymentPlanItems();

        $('.initialFocus').focus();

        var SwitchTabs = function (e) {
            if ($tabs !== undefined) {
                var activeTab = 0;
                $(".ui-tabs-panel").each(function (i, tab) {
                    if ($(tab).attr('aria-expanded') == "true") {
                        activeTab = i;
                    }
                });
                var toActivateTab = activeTab + 1;
                if (toActivateTab > totalTabs) {
                    toActivateTab = 0;
                }
                $tabs.tabs('option', 'active', toActivateTab);
            }
        }

        $('body').on('keypress', function (e) {
            if (e.which == 178) {
                if ($(':focus').hasClass('auto')) {
                    $(':focus').autocomplete('close');
                    $(':focus').autocomplete('disable');
                    e.preventDefault();
                    SwitchTabs();
                    return false;
                } else if ($(':focus').length == 0) {
                    SwitchTabs();
                    return false;
                } else {
                    e.preventDefault();
                    SwitchTabs();
                    return false;
                }
            } else {
                if ($(':focus').hasClass('auto')) {
                    $(':focus').autocomplete('enable');
                }
            }
        });

        $('input.numeric').ForceNumericOnly();

        var previousOPStatus;
        $('body').on('focus', 'select.statusDrop', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            previousOPStatus = $(this).val();

            if ($(this).find('option.lock').length > 0) {
                $(this).find('option').each(function (i, y) {
                    if (!$(y).hasClass('lock')) {
                        $(y).prop('disabled', 'disabled');
                    }
                });
            }
        }).on('change', 'select.statusDrop', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            var statusID = $(this).val();
            if ((statusID == 4 || statusID == 5 || statusID == 6) && (previousOPStatus < 4)) {
                var time = moment().format("DD/MM/YYYY HH:mm");
                var inputImplementation = $(this).parent().parent().find('td.implementation').find('input.procImplementation');
                inputImplementation.val(time);
                inputImplementation.attr('value', time);
                inputImplementation.removeClass('original');
                inputImplementation.addClass('changed');

                var removeChangedFromDateTimeProcedures = function () {
                    inputImplementation.removeClass('changed');
                    inputImplementation.addClass('original');
                };
                setTimeout(removeChangedFromDateTimeProcedures, 1500);

                SharedOrderFunctions.checkDatesWhenProcedureDateChangedInOrder(inputImplementation);
            }
            previousOPStatus = statusID;

            GetInvoiceInformation();
        });

        $('body').on('click', ".radText, .tecText, .roomText", function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $(this).select();
        });

        $('.switchRequestingAndCC').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            SharedOrderFunctions.SwitchRequestingAndCCApplicant(viewbagUniquePrefix);
        });

        if (patientModel.GeneralPractitionerID) {
            $('#addGeneralPractitionerAsApp' + viewbagUniquePrefix).removeClass('inActive');
            $('#addGeneralPractitionerAsAppCC' + viewbagUniquePrefix).removeClass('inActive');
            $('#addGeneralPractitionerAsAppCC2' + viewbagUniquePrefix).removeClass('inActive');

            $('#addGeneralPractitionerAsApp' + viewbagUniquePrefix).on('click', function (e) {
                if ($(this).hasClass('inActive')) {
                    e.preventDefault();
                } else {
                    SharedOrderFunctions.LoadApplicantWithID(patientModel.GeneralPractitionerID, "App", viewbagUniquePrefix);
                    LoadRequestForm('App', patientModel.GeneralPractitionerID, htmlDecode(patientModel.GeneralPractitionerText));
                }
            });

            $('#addGeneralPractitionerAsAppCC' + viewbagUniquePrefix).on('click', function (e) {
                if ($(this).hasClass('inActive')) {
                    e.preventDefault();
                } else {
                    SharedOrderFunctions.LoadApplicantWithID(patientModel.GeneralPractitionerID, "AppCC", viewbagUniquePrefix);
                    LoadRequestForm('AppCC', patientModel.GeneralPractitionerID, htmlDecode(patientModel.GeneralPractitionerText));
                }
            });

            $('#addGeneralPractitionerAsAppCC2' + viewbagUniquePrefix).on('click', function (e) {
                if ($(this).hasClass('inActive')) {
                    e.preventDefault();
                } else {
                    SharedOrderFunctions.LoadApplicantWithID(patientModel.GeneralPractitionerID, "AppCC2", viewbagUniquePrefix);
                    LoadRequestForm('AppCC2', patientModel.GeneralPractitionerID, htmlDecode(patientModel.GeneralPractitionerText));
                }
            });
        }

        $('#MergeWithPatient_UID').val("");

        $('table#mergePatientTable' + viewbagUniquePrefix + ' tbody').on('dblclick', 'tr.record', function (e) {
            var id = $(this).find('td.id').text();
            if (id) {
                useFilingCabinet('/Patients/Detail/' + id);
            }
        });

        $('input#searchMergePatient' + viewbagUniquePrefix).bind('keydown', function (e) {
            if (e.keyCode == 13) {
                SharedOrderFunctions.FindPatientsToMergeForOrder(viewbagUniquePrefix, modelPatientID);
                return false;
            }
        });

        $('table#mergePatientTable' + viewbagUniquePrefix + ' tbody').on('click', 'tr.record', function (e) {
            $('table#mergePatientTable' + viewbagUniquePrefix + ' tbody tr.record').removeClass('activeRecord');
            $(this).addClass('activeRecord');
            $('button#btnConfirmMerge' + viewbagUniquePrefix).removeAttr('disabled');

        });

        $('#divMergePatient' + viewbagUniquePrefix).dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            dialogClass: 'no-close',
            appendTo: "#contentView",
            title: $("<div/>").html(resourceTemporaryPatient + ' - ' + resourceMergeTitle).text()
        });

        $('#btnCancelMerge' + viewbagUniquePrefix).on('click', function (e) {
            $('#divMergePatient' + viewbagUniquePrefix).dialog('close');
            $('form#addOrderForm').submit();
        });

        $('#btnConfirmMerge' + viewbagUniquePrefix).on('click', function (e) {
            $('#divMergePatient' + viewbagUniquePrefix).dialog('close');
            var row = $('table#mergePatientTable' + viewbagUniquePrefix + ' tbody').find('tr.activeRecord');

            var id = row.find('td.id').text();
            if (id) {
                $('#MergeWithPatient_UID').val(id);
                $('form#addOrderForm').submit();
            } else {
                $('form#addOrderForm').submit();
            }
        });

        $('#divEditWeight' + viewbagUniquePrefix + ' input').ForceNumericOnly();
        $('#divEditLength' + viewbagUniquePrefix + ' input').ForceNumericWithoutPunctuation();

        if (viewbagVisitRequiredError) {
            $('div#fullVisitContainer span.visitValidation').text(viewbagVisitRequiredError);
            $('div#fullVisitContainer span.visitValidation').show();
            $('a[href="#visitTab"]').trigger('click');
            $('#openVisitTab').trigger('click');
        } else {
            $('div#fullVisitContainer span.visitValidation').hide();
        }

        if (viewbagErrorPaymentPlan) {
            $('#errorPaymentPlanDialog').dialog('open');
        }

        if (viewbagGeneralPractitionerCC && viewbagGeneralPractitionerCC == 'True') {
            SharedOrderFunctions.LoadPhyscianExportFormatsForApplicantType('AppCC');
        }

        if (viewbagApplicantFromVisitMovement && viewbagApplicantFromVisitMovement == 'True') {

            var promise = Promise.all([
                SharedOrderFunctions.LoadPhyscianExportFormatsForApplicantType('App'),
                new Promise(function(resolve) {
                    LoadRequestForm('App', $('input#Applicant_UID').attr('value'), $('input#Applicant_Text').attr('value'));
                    SharedOrderFunctions.setActiveApplicantDetailAndRemoveMenuOptions(true, "App", viewbagUniquePrefix);
                    resolve();
                })
            ])

            SharedOrderFunctions.saveChecker.queueSaveBlockingPromise(promise);
        }

        if (modelInvoiceCertificate && modelInvoiceCertificate == 'True') {
            $('input#InvoiceCertificate').prop('checked', true);
        } else {
            $('input#InvoiceCertificate').prop('checked', false);
        }

        if (modelInvoiceSituation_UID == '3' || modelInvoiceSituation_UID == '6') {
            if (modelInvoicePaymentMethod == '2' || modelInvoicePaymentMethod == '4') {
                $('div#invoiceInvoiceCertificate').hide();
            } else {
                $('div#invoiceInvoiceCertificate').show();
            }
        }

        SetHealthInsuranceParameters(modelInvoicePaymentMethod);

        $('#loading').hide();
    }
}
